/*
T Santosh Kumar 24/03/2023 2701306337 Added the Icon for Add Corporate Button
Akhila 04/18/2023 3225736869 rename client Number to client code and rearrange
Ravi 05/31/2023 3225736869 changed delete popup message
Ravi 06/14/2023 3225736869 rename Revone to RevOne
Ravi 06/16/2023 3225736869 rename Company to companies
Sohe 12/06/2023 3225736869 Fixed Label Space Issue
uday 06/12/2023 3225736869 fixed scroll issue
Sohel 12/07/2023 3225736869 Fixed default Search Issue 
Sohel 12/07/2023 3225736869 Fixed Tenants default Search Issue
Sohel 12/07/2023 3225736869 Fixed table Reset Issue
*/

import React, {createRef, useEffect, useMemo, useRef, useState} from 'react';
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../components/TableIcons';
import {httpPaginationPost} from '../../util/Rest';
import {defaultRows, tablePageRows} from '../../constants/ReusableTablePagination';
import GuiTable from '../../components/FormComponents/GuiTable';
import {useDispatch, useSelector} from 'react-redux';
import DialogBox from '../../components/DialogBox';
import CompanyForm from './CompanyForm';
import SiteForm from './Organization/SiteForm';
import CorporateForm from './CorporateForm';
import AddCompanyForm from './AddCompanyForm';
import {ErrorSnackbar, SuccessSnackbar} from '../../components/CustomSnackBar';
import AddIcon from '@material-ui/icons/AddOutlined';
import {
  deleteClient,
  getAddressDetails,
  getContactsDetails,
  getNotesDetails,
  getPhonesDetails,
  getServiceClientDetails,
  resetToast,
} from '../../redux/reducers/clientMangement/Organizaation';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {getIdBasedOnType} from './utils';
import DeleteTableRecordPopup from '../../util/DeleteTableRecordPopup';
import {TENANTS_REVONE_COMPANIES} from '../../constants/ReusableConstants';

export default function searchTable({
  setEdit,
  setOrgType,
  searchData,
  isSubmit,
  setSubmit,
  setTabValue,
  setId,
  setSiteTableData,
  organizationAccess,
  tenants,
}) {
  const {errorMsg, successMsg, status} = useSelector(({organization}) => organization);
  const [tableData, setTableData] = useState([]);
  const rowDataRef = useRef(null);
  const [isDelete, setIsDelete] = useState(false);
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [open, setOpen] = useState(false);
  const serviceColumns = [
    {
      title: 'Client Name',
      field: 'clientName',
    },
    {
      title: 'Client Code',
      field: 'clientNumber',
    },
    {
      title: 'Client Class',
      field: 'clientClass',
    },
    {
      title: `${TENANTS_REVONE_COMPANIES} Name`,
      field: 'companyName',
    },
    {
      title: 'Corporate Name',
      field: 'corporateName',
    },
    {
      title: 'Department Name',
      field: 'serviceName',
    },
    {
      title: 'Site Name',
      field: 'siteName',
    },
    {
      title: 'Invoice',
      field: 'invoice',
    },
    {
      title: 'Invoice Type',
      field: 'invoiceType',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.invoiceType ? rowData?.invoiceType : '-'}
          </div>
        </>
      ),
    },
    {
      title: 'Authority to Sue',
      field: 'authorityToSue',
    },
    {
      title: 'Status',
      field: 'status',
    },
    {
      title: 'Wait Date',
      field: 'waitDate',
    },
    // {
    //   title: "Client Id",
    //   field: "clientId",
    // },
  ];

  const siteColumns = [
    {
      title: 'Site Name',
      field: 'siteName',
    },
    {
      title: 'Aggregation Legal Collection',
      field: 'agregateLegalCollection',
    },
    {
      title: 'Allow Payment Aggregation',
      field: 'allowPaymentAgregation',
    },
    {
      title: 'Client Prefix',
      field: 'clientPrefix',
    },
    {
      title: 'Corporate Name',
      field: 'corporateName',
    },
    {
      title: 'Invoice',
      field: 'invoiceAtThisLevel',
    },
    {
      title: 'Invoice Type',
      field: 'invoiceType',

      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.invoiceType ? rowData?.invoiceType : '-'}
          </div>
        </>
      ),
    },
  ];
  const corporateColumns = [
    {
      title: 'Corporate Name',
      field: 'corporateName',
    },
    {
      title: 'Aggregation Legal Collection',
      field: 'agregateLegalCollection',
    },
    {
      title: 'Allow Payment Aggregation',
      field: 'allowPaymentAgregation',
    },
    {
      title: 'Invoice',
      field: 'invoiceAtThisLevel',
    },
    {
      title: 'Invoice Type',
      field: 'invoiceType',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.invoiceType ? rowData?.invoiceType : '-'}
          </div>
        </>
      ),
    },
    {
      title: 'Authority to Sue',
      field: 'authorityToSue',
    },
  ];
  const companyColumns = [
    {
      title: `${TENANTS_REVONE_COMPANIES} Name`,
      field: 'companyName',
    },
  ];
  const clientManagementSessionStorage = JSON.parse(
    sessionStorage.getItem('ClientManagement'),
  ); 
  const tenantSessionStorage = JSON.parse(
    sessionStorage.getItem('Tenants'),
  ); 
  if (clientManagementSessionStorage && !isSubmit && !tenants) {
    searchData = clientManagementSessionStorage;
  }
  if(tenantSessionStorage && tenants && !isSubmit){
    searchData = tenantSessionStorage
  }
  const tableColumns = useMemo(
    () =>
      searchData?.organizationType?.value === 'Service-Client' ?
        serviceColumns :
        searchData?.organizationType?.value === 'Corporate' ?
          corporateColumns :
          searchData?.organizationType?.value === 'Company' ?
            companyColumns :
            searchData?.organizationType?.value === 'Site' ?
              siteColumns :
              serviceColumns,
    [searchData?.organizationType?.value,isSubmit],
  );

  useEffect(() => {
    if (tableRef?.current && (isSubmit || status === 200)) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [isSubmit, searchData, status]);

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (successMsg || errorMsg) {
      handleDeleteClose();
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [successMsg, errorMsg]);
  const handleDeleteClose = () => {
    setIsDelete(false);
    rowDataRef.current = null;
  };

  const handleDelete = () => {
    const id = getIdBasedOnType(rowDataRef.current?.type);
    dispatch(deleteClient(rowDataRef.current?.[id], rowDataRef.current?.type));
  };
  const getName = (rowData) => {
    const type = rowData?.type?.toLowerCase();
    if (type === 'service-client') {
      return rowData.clientName;
    } else {
      return rowData[type + 'Name'];
    }
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title={`Delete ${
          rowDataRef.current?.type === 'Company' ?
            TENANTS_REVONE_COMPANIES :
            rowDataRef.current?.type === 'Service-Client' ?
              'Department' :
              rowDataRef.current?.type || ''
        }`}
        value={`Are you sure you want to delete the ${
          rowDataRef.current?.type && getName(rowDataRef.current)
        } ${
          rowDataRef.current?.type === 'Company' ?
            TENANTS_REVONE_COMPANIES :
            rowDataRef.current?.type === 'Service-Client' ?
              'Department' :
              rowDataRef.current?.type || ''
        }?`}
        handleSubmit={handleDelete}
      />
      <DialogBox
        open={open}
        dialogClose={handleClose}
        hideFooter={true}
        maxWidth={'lg'}
        title={`Add ${
          searchData?.organizationType?.value === 'Company' ?
            TENANTS_REVONE_COMPANIES :
            searchData?.organizationType?.value === 'Service-Client' ?
              'Department' :
              searchData?.organizationType?.label
        }`}
      >
        {searchData?.organizationType?.value === 'Service-Client' ? (
          <CompanyForm setOpen={setOpen} tableData={tableData} />
        ) : searchData?.organizationType?.value === 'Site' ? (
          <SiteForm setOpen={setOpen} tableData={tableData} />
        ) : searchData?.organizationType?.value === 'Corporate' ? (
          <CorporateForm setOpen={setOpen} tableData={tableData} />
        ) : searchData?.organizationType?.value === 'Company' ? (
          <AddCompanyForm setOpen={setOpen} tableData={tableData} />
        ) : null}
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields tablescroll-block">
          <GuiTable
            title={`${
              searchData?.organizationType?.value === 'Company' ?
                TENANTS_REVONE_COMPANIES :
                searchData?.organizationType?.label
            } Details`}
            columns={tableColumns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `organization/search/all`;
                const bodyObj = {
                  clientClass: searchData?.clientClass?.value ? searchData.clientClass?.value : '',
                  companyName: searchData?.companyName?.companyName ?
                    searchData.companyName?.companyName :
                    '',
                  corporateName: searchData?.corporateName?.corporateName ?
                    searchData?.corporateName?.corporateName :
                    '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  page: isSubmit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  clientName: searchData?.clientName ? searchData.clientName : '',
                  clientNumber: searchData?.clientNumber ? searchData.clientNumber : '',
                  siteName: searchData?.siteName?.siteName ? searchData.siteName?.siteName : '',
                  type: searchData?.organizationType?.value ?
                    searchData?.organizationType?.value :
                    'Service-Client',
                  status: searchData?.status?.value ?
                    searchData?.status?.value === 'All' ?
                      '' :
                      searchData?.status?.value :
                    '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const serviceClientSearchResponse =
                          response.data.response.serviceClientSearchResponse;
                        const corporateResponse = response.data.response.corporateResponse;
                        const companyResponse = response.data.response.companyResponse;
                        const siteResponse = response.data.response.siteResponce;
                        const getData = (type) => {
                          if (type === 'Service-Client') {
                            return serviceClientSearchResponse;
                          } else if (type === 'Site') {
                            return siteResponse;
                          } else if (type === 'Corporate') {
                            return corporateResponse;
                          } else if (type === 'Company') {
                            return companyResponse;
                          }
                        };
                        const newData = getData(searchData?.organizationType?.value);
                        setTableData(newData);
                        setSiteTableData(newData);
                        resolve({
                          data: newData.length > 0 ? newData : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(newData.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'right',
              showTextRowsSelected: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      disabled={!organizationAccess?.add}
                      startIcon={<AddIcon />}
                    >
                      {`Add ${searchData?.organizationType?.value === 'Company' ?
                        TENANTS_REVONE_COMPANIES :
                        searchData?.organizationType?.label}`}
                    </Button>
                  </>
                ),
                disabled: !organizationAccess?.add,
                isFreeAction: true,
                onClick: (event) => {
                  setOpen(true);
                },
              },
              {
                icon: () => <EditOutlinedIcon />,
                tooltip: 'Edit',
                onClick: (event, rowData) => {
                  setEdit(true);
                  sessionStorage.setItem('orgType', rowData?.type);
                  setTabValue(1);
                  setOrgType(rowData?.type);
                  const id = getIdBasedOnType(rowData?.type);
                  setId(rowData[id]);
                  dispatch(getServiceClientDetails(rowData[id], rowData?.type));
                  dispatch(getContactsDetails(rowData[id], rowData?.type));
                  dispatch(getAddressDetails(rowData[id], rowData?.type));
                  dispatch(getPhonesDetails(rowData[id], rowData?.type));
                  dispatch(getNotesDetails(rowData[id], rowData?.type));
                },
              },
              {
                icon: () => <DeleteOutlined />,
                tooltip: 'Delete',
                disabled: !organizationAccess?.delete,
                onClick: (event, rowData) => {
                  rowDataRef.current = rowData;
                  setIsDelete(true);
                },
              },
            ]}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
          />
        </div>
      </Grid>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
}
